import ContainerDefault from '../../../Component/Dashboard/Default/Default'
import Dashboard from '../../../Component/Dashboard/Dashboard/Dashboard'
const Default = () => {
  return (
    <div className='page-body'>
      {/* <ContainerDefault /> */}
      <Dashboard />
    </div>
  )
}

export default Default